import React, { Component } from 'react';
import logo from './logo.svg';
import LightBox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import './App.css';

const AWS = require('aws-sdk')

class App extends Component {

  state = {
    images: [],
    photoIndex: 0,
    isOpen: false
  }

  constructor(props) {
    super(props)

    let config = new AWS.Config({region: 'us-west-1', credentials: 'anonymous'})

    let params = {
      Bucket: 'marana-evidence',
      MaxKeys: 1000
    }

    let s3 = new AWS.S3(config)
    s3.makeUnauthenticatedRequest('listObjects', params, (err, data) => {

      let imgs = data.Contents.map(i => 'https://s3-us-west-1.amazonaws.com/marana-evidence/' + i.Key)

      this.setState({
        images: imgs
      })
    })
  }

  render() {

    const { photoIndex, isOpen, images } = this.state;

    return (
      <div>
        <ul className="photo-list">



          { images.map(img => <li><img onClick={()=> {
            this.setState({
              isOpen: true,
              photoIndex: images.indexOf(img)
            })
          }} src={img} /><div className="filename">{img.substr(img.lastIndexOf('/')+1)}</div></li>)}
        </ul>
      {isOpen ? <LightBox
        mainSrc={images[photoIndex]}
        nextSrc={images[(photoIndex + 1) % images.length]}
        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
        imageTitle={images[photoIndex].substr(images[photoIndex].lastIndexOf('/')+1)}
        onCloseRequest={() => this.setState({ isOpen: false})}
        onMovePrevRequest={() =>
          this.setState({
            photoIndex: (photoIndex + images.length - 1) % images.length,
          })
        }
        onMoveNextRequest={() =>
          this.setState({
            photoIndex: (photoIndex + 1) % images.length,
          })
        }
      />: null}
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js